export default __webpack_public_path__ + "static/media/logo-audo.8439113d.svg";